import { createContext, useContext, useEffect, useState } from "react";
import apiService from "../api/apiService";

const DataContext = createContext(null);
const hotelId = localStorage.getItem("hotel");

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({
    bookings: [],
    rooms: [],
    guests: [],
    roomPrices: [],
    invoices: [],
  });

  const [loading, setLoading] = useState({
    bookings: false,
    rooms: false,
    guests: false,
    roomPrices: false,
    invoices: false,
  });

  const setApiLoading = (key, value) => {
    setLoading((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    fetchBookings();
    fetchRooms();
    fetchGuests();
    fetchRoomPrices();
    fetchInvoices();
  }, []);

  const fetchBookings = async () => {
    setApiLoading("bookings", true);
    try {
      const newBookings = await apiService.get(
        `/bookings/?hotel=${hotelId}&is_archive=false`,
      );
      setData((prev) => ({
        ...prev,
        bookings: newBookings,
      }));
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setApiLoading("bookings", false);
    }
  };

  const fetchRooms = async () => {
    setApiLoading("rooms", true);

    try {
      const newRooms = await apiService.get(
        `/rooms/?hotel=${hotelId}&is_archive=false`,
      );
      setData((prev) => ({
        ...prev,
        rooms: newRooms,
      }));
    } catch (error) {
      console.error("Error fetching rooms:", error);
    } finally {
      setApiLoading("rooms", false);
    }
  };

  const fetchGuests = async () => {
    setApiLoading("guests", true);
    try {
      const newGuests = await apiService.get(
        `/guests/?hotel=${hotelId}&is_archive=false`,
      );
      setData((prev) => ({
        ...prev,
        guests: newGuests,
      }));
    } catch (error) {
      console.error("Error fetching guests:", error);
    } finally {
      setApiLoading("guests", false);
    }
  };

  const fetchRoomPrices = async () => {
    setApiLoading("roomPrices", true);
    try {
      const newRoomPrices = await apiService.get(
        `/room-prices/?hotel=${hotelId}&is_archive=false`,
      );
      setData((prev) => ({
        ...prev,
        roomPrices: newRoomPrices,
      }));
    } catch (error) {
      console.error("Error fetching room prices:", error);
    } finally {
      setApiLoading("roomPrices", false);
    }
  };

  const fetchInvoices = async () => {
    setApiLoading("invoices", true);
    try {
      const newInvoices = await apiService.get(
        `/invoices/?hotel=${hotelId}&is_archive=false`,
      );
      setData((prev) => ({
        ...prev,
        invoices: newInvoices,
      }));
    } catch (error) {
      console.error("Error fetching invoices:", error);
    } finally {
      setApiLoading("invoices", false);
    }
  };

  return (
    <DataContext.Provider value={{ data, loading }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
